const SET_ASCX_HTML = '[exam][question][ascx]set.ascx.html';			

export {SET_ASCX_HTML}
